export default __webpack_public_path__ + "static/media/huyndai_steel.87323add.png";